import { useEffect, useRef } from 'react';

// ─── Resume/autosave progres tes ───────────────────────────────
// Latar belakang: user kadang keluar dari sesi tes tanpa sengaja di
// tengah pengerjaan (koneksi putus, app di-background, gangguan lain
// di HP/browser) dan selama ini itu berarti harus mengulang dari awal
// — soal diacak ulang dan jawaban yang sudah diisi hilang semua.
//
// Modul dipasangi hook ini supaya progres (indeks soal, jawaban, sisa
// waktu) disimpan otomatis ke localStorage tiap beberapa saat selama
// fase "sedang mengerjakan". Kalau modul dibuka lagi sebelum progres
// itu dihapus (selesai/expired), tawarkan lanjutkan dari titik terakhir
// alih-alih mulai baru.
//
// PENTING: yang disimpan cuma ID soal + urutan (bukan seluruh konten
// soal/SVG) supaya ringan — saat resume, modul harus mencocokkan ID itu
// balik ke bank soal aslinya untuk merekonstruksi soalList persis sama.

const PREFIX = 'resumeTes_';
const KADALUARSA_MS = 12 * 60 * 60 * 1000; // 12 jam — progres lebih lama dianggap basi

function buatKey(modulId, tryoutId) {
  return `${PREFIX}${modulId}_${tryoutId || 'latihan'}`;
}

export function simpanProgresTes(modulId, tryoutId, data) {
  try {
    localStorage.setItem(buatKey(modulId, tryoutId), JSON.stringify({ ...data, disimpanAt: Date.now() }));
  } catch (e) {
    // localStorage penuh/nonaktif (mode incognito dsb) — bukan fatal, cuma berarti
    // fitur resume tidak aktif untuk sesi ini, tes tetap bisa dikerjakan normal.
  }
}

export function bacaProgresTes(modulId, tryoutId) {
  try {
    const raw = localStorage.getItem(buatKey(modulId, tryoutId));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    if (Date.now() - (data.disimpanAt || 0) > KADALUARSA_MS) {
      hapusProgresTes(modulId, tryoutId);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
}

export function hapusProgresTes(modulId, tryoutId) {
  try {
    localStorage.removeItem(buatKey(modulId, tryoutId));
  } catch (e) {}
}

// Cari ulang soal dari bank berdasar array ID tersimpan, urut persis seperti
// semula (bukan di-generate ulang/acak baru).
export function ambilSoalDariId(bank, ids) {
  const byId = {};
  bank.forEach(s => { byId[s.id] = s; });
  return ids.map(id => byId[id]).filter(Boolean);
}

// Hook: autosave berkala (debounce ringan) selama `aktif` true. `data` harus
// berupa objek serializable (indeks, jawaban, waktu, dsb) — dibandingkan lewat
// JSON.stringify supaya effect ini cuma jalan kalau isinya benar berubah.
export function useAutosaveTes(aktif, modulId, tryoutId, data) {
  const timeoutRef = useRef(null);
  const dataStr = JSON.stringify(data);

  useEffect(() => {
    if (!aktif) return undefined;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      simpanProgresTes(modulId, tryoutId, JSON.parse(dataStr));
    }, 400);
    return () => clearTimeout(timeoutRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aktif, modulId, tryoutId, dataStr]);
}
